import axios from "@/plugins/axios";

// Migrasi Data module — Tangkapan (DOSM capture DB) → Analisis (this app's DB).
// Backend: hies-unijaya-backend/src/routes/migrasi.route.js, documented in
// hies-unijaya-backend/docs/migrasi-tangkapan-ke-analisis.md.
//
// Every endpoint here is ADMIN-only (JWT + requireAdmin server-side). The
// external two-key trigger (POST /migrasi/trigger) is deliberately NOT wrapped:
// it exists for the tangkapan site to call server-to-server, and its secrets
// must never reach a browser bundle.
//
// The SSE trigger is not here either — it needs `fetch` with a streaming
// response body, which axios cannot give us in the browser. See
// MigrasiData.vue's startMigrasi().
const API = process.env.VUE_APP_API_URL;

// Table sets the backend understands. 'role' is the daily set (access control +
// operational + lookups); 'heavy' is the on-demand raw survey capture, ~90% of
// which is blk_iii.
export const MIGRASI_SETS = [
  { value: "role", text: "Harian (capaian, operasi, lookup)", icon: "mdi-account-key" },
  { value: "heavy", text: "Berat (data tinjauan mentah)", icon: "mdi-database" },
  { value: "all", text: "Semua (harian + berat)", icon: "mdi-database-arrow-down" },
];

export default class MigrasiDataServices {
  // Link state + what each set would pull. Safe to call before anything is run;
  // an unreachable tangkapan comes back as { tangkapan: { ok: false, error } },
  // not an HTTP error, so the page can render a red box instead of blowing up.
  async status() {
    const res = await axios.get(`${API}/migrasi/status`);
    return res.data || {};
  }

  // Last 50 jobs.
  async history() {
    const res = await axios.get(`${API}/migrasi/history`);
    return (res.data && res.data.jobs) || [];
  }

  // One job with its full log.
  async job(id) {
    const res = await axios.get(`${API}/migrasi/${id}`);
    return (res.data && res.data.job) || null;
  }

  // Lightweight lock probe — is a migration running right now?
  async running() {
    const res = await axios.get(`${API}/migrasi/running`);
    return res.data || { running: false, job: null };
  }

  // Force-release a stuck 'running' row. Does NOT stop work already in flight;
  // it only clears the lock so a new run can start.
  async unlock() {
    const res = await axios.post(`${API}/migrasi/unlock`);
    return res.data || {};
  }

  // Daily-migration cron settings.
  async getSchedule() {
    const res = await axios.get(`${API}/migrasi/schedule`);
    return res.data || {};
  }

  // payload: { enabled?, cronExpression?, timezone? }
  async saveSchedule(payload) {
    const res = await axios.put(`${API}/migrasi/schedule`, payload);
    return res.data || {};
  }

  // EVERY setting this feature has lives in the shared `analisis_config` table
  // under the single type 'migrasi_data' — perf knobs and the daily cron alike —
  // so it uses the same /admin/config CRUD as the ClickHouse sync knobs.
  //
  // The `schedule_*` rows are returned here too, but the page filters them out
  // of the Prestasi card: they already have a purpose-built editor (mode / time
  // / timezone) above it, and showing a raw '0 3 * * *' text box beside it would
  // be two ways to edit one value.
  async getConfigs() {
    const res = await axios.get(`${API}/admin/config?type=migrasi_data`);
    return (res.data && res.data.config) || [];
  }

  async saveConfig(id, value) {
    const res = await axios.put(`${API}/admin/config/${id}`, { value });
    return (res.data && res.data.config) || null;
  }
}
